import React, { Component } from "react";
import MenuBar from "./navbar";
import { Card, Container, Row, Col } from "react-bootstrap";
import Header from "./header";
import { BASE_URL } from "./utility";
import Contact from "./contact";

class About extends Component {
  render() {
    return (
      <div
        style={{
          backgroundImage: `url(${BASE_URL + "download/general/bg"})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          paddingBottom: "3rem",
        }}
      >
        <Header />
        <MenuBar />
        <Container style={{ marginTop: "2rem" }}>
          {/* Our History */}
          <Card
            className="mb-4 shadow-sm"
            style={{ borderRadius: "15px", backgroundColor: "rgba(255,255,255,0.95)" }}
          >
            <Card.Body>
              <Card.Title style={{ color: "#007bff" }}>Our History</Card.Title>
              <hr />
              <p>
                Established in 2005, <strong>Rainbow Touch</strong> has grown to become a trusted wholesaler and trader of a diverse range of interior and decor solutions, including{" "}
                <strong>Designer Wallpapers, PVC Panels, WPC Louvers, Wooden Flooring, Artificial Grass, False Ceilings, Door Mats</strong>, and more. Over the years, we have built a solid reputation by consistently offering quality products and excellent customer service.
              </p>
            </Card.Body>
          </Card>

          {/* Why Choose Us */}
          <Card
            className="mb-4 shadow-sm"
            style={{ borderRadius: "15px", backgroundColor: "rgba(255,255,255,0.95)" }}
          >
            <Card.Body>
              <Card.Title style={{ color: "#007bff" }}>Why Choose Us?</Card.Title>
              <hr />
              <p>
                We carefully source our products from certified and reliable vendors who use premium raw materials and advanced machinery. Our products are crafted in adherence to international quality standards, ensuring durability, aesthetics, and functionality.
              </p>
              <p>
                Additionally, we directly import select high-demand products like <strong>PVC Panels</strong>, offering customers access to the latest designs and premium quality options at competitive prices.
              </p>
            </Card.Body>
          </Card>

          {/* Overview */}
          <Card
            className="mb-4 shadow-sm"
            style={{ borderRadius: "15px", backgroundColor: "rgba(255,255,255,0.95)" }}
          >
            <Card.Body>
              <Card.Title style={{ color: "#007bff" }}>Overview</Card.Title>
              <hr />
              <p>
                <strong>Rainbow Touch</strong> is a leading name among <strong>Wallpaper and Interior Decor Dealers in NCR</strong>. Our commitment to quality, customer satisfaction, and innovation has earned us a growing client base, both locally and beyond.
              </p>
              <p>
                Our well-trained team is passionate about helping customers find the right products for their spaces, and we are always ready to answer queries and provide personalized recommendations.
              </p>
            </Card.Body>
          </Card>

          {/* Our Services & Reach */}
          <Card
            className="mb-4 shadow-sm"
            style={{ borderRadius: "15px", backgroundColor: "rgba(255,255,255,0.95)" }}
          >
            <Card.Body>
              <Card.Title style={{ color: "#007bff" }}>Our Services & Reach</Card.Title>
              <hr />
              <Row>
                <Col md={12}>
                  <p>
                    At <strong>Rainbow Touch</strong>, we pride ourselves on delivering not just products, but complete interior solutions tailored to the needs of homes, offices, commercial spaces, and hospitality projects.
                  </p>
                  <p>
                    We cater to customers <strong>throughout India</strong>, ensuring timely and safe delivery of our extensive range of interior décor materials — no matter where you are located. Our logistics and supply chain network is optimized to handle orders both in urban centers and remote regions with equal efficiency.
                  </p>
                  <p>
                    From <strong>Designer Wallpapers</strong> and <strong>PVC Panels</strong> to <strong>Wooden Flooring, WPC Louvers, Artificial Grass, Customized Wall Murals</strong>, and more — we offer a complete portfolio to transform and beautify any space.
                  </p>
                  <p>
                    Our clientele includes architects, interior designers, construction firms, retail showrooms, institutions, and homeowners, making us a trusted and widely recommended brand in the Indian décor industry.
                  </p>
                </Col>
              </Row>
            </Card.Body>
          </Card>

          {/* Contact Section */}
          <Contact />

        </Container>
      </div>
    );
  }
}

export default About;
